<template>
  <div class="home">
    <canvas id="canvas"></canvas>
    <p class="click-anywhere">Changes are being made... please check back soon.</p>
    <img class="main" src="../assets/main.png" alt="Cindy Chea" />
    <img class="main2" src="../assets/main2.png" alt="Cindy Chea" />
    <p class="scroll-msg">Click Anywhere</p>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import backgroundInit from '@/background-effect.js'

export default {
  name: 'home',
  components: {
    HelloWorld
  },
  mounted() {
    backgroundInit();
  }
}
</script>

<style lang="scss">
.home {
	margin: 0;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  #canvas {
    height: 100vh;
    width: 100%;
    overflow: hidden;
    background: #242B38;
    margin: 0;
    z-index: 1;
  }
  .click-anywhere {
    position: absolute;
    top: 0;
    left: 50%;
    color: #9c5f7c;
    transform: translateX(-50%);
    font-family: 'Montserrat', sans-serif;
    pointer-events: none;
  }
  img {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    z-index: 2;
    pointer-events: none;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    transition: opacity 1s ease-in-out;
  }
  @keyframes mainFadeInOut {
    0% {
      opacity:1;
    }
    45% {
      opacity:1;
    }
    55% {
      opacity:0;
    }
    100% {
      opacity:0;
    }
  }
  .main2 {
  animation-name: mainFadeInOut;
  animation-timing-function: ease-in;
  animation-iteration-count: infinite;
  animation-duration: 3s;
  animation-direction: alternate;
  }
  .scroll-box {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 3px;
    padding: 10px 15px;
    height: 35px;
    border: 2px solid #9c5f7c;
    border-radius: 25px;
    opacity: 0.75;
    box-sizing: content-box;
    pointer-events: none;
    .scroller {
      width: 3px;
      height: 10px;
      border-radius: 25%;
      background-color: #9c5f7c;
      animation-name: scroll;
      animation-duration: 2.2s;
      animation-timing-function: cubic-bezier(.15,.41,.69,.94);
      animation-iteration-count: infinite;
    }
    @keyframes scroll {
      0% { opacity: 0; }
      10% { transform: translateY(0); opacity: 1; }
      100% { transform: translateY(15px); opacity: 0;}
    }
  }
  .scroll-msg {
    position: absolute;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    color: #9c5f7c;
    font-family: 'Montserrat', sans-serif;
    font-size: 0.7em;
    pointer-events: none;
  }
}
</style>

